import React, { Suspense } from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import store from "./app/store";
import { Provider } from "react-redux";
import NextUIProviderWrapper from "./components/NextUIProviderWrapper";
import i18n from "./i18n";
import { I18nextProvider } from "react-i18next";
import MediaContextProvider from "./Context/Media";
import NoInternetConnection from "./pages/NoInternetConnection";
import ErrorBoundary from "./pages/ErrorBoundary ";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // <React.StrictMode>
  <NoInternetConnection>
    <I18nextProvider i18n={i18n}>
      <ErrorBoundary>
        <NextUIProviderWrapper>
          <Provider store={store}>
            <App />
          </Provider>
        </NextUIProviderWrapper>
      </ErrorBoundary>
    </I18nextProvider>
  </NoInternetConnection>

  // </React.StrictMode>
);

reportWebVitals();
